import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-4 question-container background-white" }
const _hoisted_2 = { class: "d-none type-question" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = { class: "text-sm-start bg-white" }
const _hoisted_5 = { class: "text-large" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "text-large" }
const _hoisted_8 = { class: "d-flex mx-0 pb-4 bg-white" }
const _hoisted_9 = {
  key: 0,
  id: "editor",
  class: "markdown-editor w-full fill-height",
  style: {"min-height":"560px"}
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "summary-sore"
}
const _hoisted_12 = { class: "percent-number" }
const _hoisted_13 = { class: "bg-white" }
const _hoisted_14 = {
  key: 0,
  class: "skill-text ps-1 my-3"
}
const _hoisted_15 = {
  key: 0,
  class: "skill-table"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "font-weight-bold" }
const _hoisted_18 = {
  key: 0,
  class: "other-gpt-assessments"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "explain-title m-0 ps-1 text-secondary d-flex py-1" }
const _hoisted_23 = { class: "text-gray ms-2" }
const _hoisted_24 = { class: "ps-2 list-question-history" }
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href"]

import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue'
import QuestionRadio from './QuestionRadio.vue'
import QuestionCheckBox from './QuestionCheckBox.vue'
import QuestionSelect from './QuestionSelect.vue'
import { useExamResultQuestionBody, ExamResultQuestionBodyProps } from './useExamResultQuestionBody'
import * as AceEditor from 'brace'
import 'brace/mode/javascript'
import 'brace/mode/typescript'
import 'brace/mode/ruby'
import 'brace/mode/python'
import 'brace/mode/html'
import 'brace/mode/json'
import 'brace/mode/sql'
import 'brace/theme/monokai'
import Question from '../../models/question'
import Exam from '../../models/exam'
import UserExam from '../../models/user_exam'
import SchoolSetting from '../../../api/v2/models/school_setting'
import { ExamQScoreHistory } from '../../../api/v2/models/q_score_history'

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'ExamResultQuestionBodyWeb',
  props: {
    groupIndex: {},
    currentQuestion: {},
    index: {},
    schoolSetting: {},
    exam: {},
    userExam: {},
    isMultipleQuestion: { type: Boolean, default: false },
    examQScoreHistory: { default: null }
  },
  setup(__props: any) {

const props = __props

// Use composable
const {
  show,
  LETTER_FORMAT,
  markdownParser,
  qScoreHistorySummary,
  userScore,
  maxScore,
  score,
  isPass,
  isNotFullScore,
  isNotPass,
  explanation,
  value,
  content,
  dateFormat,
  getRateScore,
  getNameByExamType,
  skillItemsName,
  getSkillsName,
  initShow
} = useExamResultQuestionBody(props)

// Local reactive data
const codeDialog = ref(false)
const dialogHTML = ref("")

// Functions
function camelCaseToWords(text: string): string {
  let result = text.replace(/([A-Z])/g, " $1")
  result = result.charAt(0).toUpperCase() + result.slice(1)
  return result.replace(/A I/g, "AI")
}

function getMaxScore(skill: any, name: string): number | undefined {
  const skillItem = skill.skillItems.find((si: any) => si.name.trim().toLowerCase() === name.trim().toLowerCase())
  if (!skillItem) return

  const allotments = skillItem.answerItems.map((ai: any) => ai.allotment)
  return Math.max(...allotments)
}

function handleCopy(e: MouseEvent) {
  const target = e.target as HTMLElement
  if (target.classList.contains("highlight-copy-btn")) {
    const container = target.closest(".highlight-container")
    const code = container?.querySelector("code")
    if (code) {
      navigator.clipboard.writeText(code.innerText)
      const actionName = target.querySelector(".action-name") as HTMLElement
      if (actionName) {
        actionName.innerText = "コピーしました！"
        setTimeout(() => {
          actionName.innerText = "コードをコピーする"
        }, 1000)
      }
    }
  }
}

function handleZoomHighlight(e: MouseEvent) {
  const target = e.target as HTMLElement
  if (target.classList.contains("highlight-zoom-btn")) {
    const container = target.closest(".highlight-container")
    if (container) {
      dialogHTML.value = container.outerHTML
      codeDialog.value = true
    }
  }
}

function getAnswerMode(): string | null {
  const match = props.currentQuestion.body.match(/code,\s?"?(\w+)"?]/)
  const code = match ? match[1] : ''
  return code && ["html", "javascript", "typescript", "ruby", "python", "json", "sql"].includes(code.toLowerCase()) ? code : null
}

const answerMode = computed(() => getAnswerMode())

function setupAceEditor() {
  const mode = getAnswerMode()
  if (!mode) return

  const editor = AceEditor.edit("editor")
  editor.getSession().setMode(`ace/mode/${mode}`)
  editor.setTheme('ace/theme/monokai')
  editor.setReadOnly(true)
  editor.setValue((value.value.join("")), 1)
}

// Lifecycle
onMounted(() => {
  document.addEventListener("click", handleCopy)
  document.addEventListener("click", handleZoomHighlight)
  
  initShow()
  nextTick(setupAceEditor)
})

onBeforeUnmount(() => {
  document.removeEventListener("click", handleCopy)
  document.removeEventListener("click", handleZoomHighlight)
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.currentQuestion.fieldType), 1 /* TEXT */),
    (__props.isMultipleQuestion)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.groupIndex) + " - " + _toDisplayString(__props.index), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("strong", _hoisted_5, "Question", 512 /* NEED_PATCH */), [
        [_vShow, __props.currentQuestion.isTestQuestion]
      ]),
      (_unref(show))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "question-body-preview-client subheading px-1",
            innerHTML: _unref(content)
          }, null, 8 /* PROPS */, _hoisted_6))
        : _createCommentVNode("v-if", true)
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _withDirectives(_createElementVNode("strong", _hoisted_7, "User Answer", 512 /* NEED_PATCH */), [
      [_vShow, __props.currentQuestion.isTestQuestion]
    ]),
    _createElementVNode("div", _hoisted_8, [
      (__props.currentQuestion.isTextarea && answerMode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
        : (__props.currentQuestion.isTextarea)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "textarea-preview question-white-bgr mt-0 p-3 mb-1",
              innerHTML: _unref(markdownParser)(_unref(value).length ? (_unref(value)[0] || _unref(value)[_unref(value).length -1 ]) : '')
            }, null, 8 /* PROPS */, _hoisted_10))
          : (__props.currentQuestion.isCheckbox || __props.currentQuestion.isMultiCheckbox || __props.currentQuestion.isSelect)
            ? (_openBlock(), _createBlock(QuestionCheckBox, {
                key: 2,
                list: __props.currentQuestion.answerItemsView ? __props.currentQuestion.answerItemsView : [],
                trueBgr: __props.exam.autoDiagnosisEnabled ? '#fff' : '#bce0fd',
                value: _unref(value) ? _unref(value) : [],
                color: "white",
                readonly: ""
              }, null, 8 /* PROPS */, ["list", "trueBgr", "value"]))
            : (__props.currentQuestion.isRadio)
              ? (_openBlock(), _createBlock(QuestionRadio, {
                  key: 3,
                  list: __props.currentQuestion.answerItemsView ? __props.currentQuestion.answerItemsView : [],
                  trueBgr: __props.exam.autoDiagnosisEnabled ? '#fff' : '#bce0fd',
                  value: _unref(value).length ? _unref(value).find(x => !!x) : '',
                  color: "white",
                  readonly: ""
                }, null, 8 /* PROPS */, ["list", "trueBgr", "value"]))
              : _createCommentVNode("v-if", true)
    ]),
    (__props.currentQuestion.skills && __props.currentQuestion.skills.length > 0 || _unref(explanation))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "explain-title m-0 ps-1 text-secondary" }, "解説", -1 /* CACHED */)),
          (__props.currentQuestion.isTextarea)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(Math.round(_unref(userScore)/_unref(maxScore)*100)), 1 /* TEXT */),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "percent" }, "%", -1 /* CACHED */)),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("span", null, _toDisplayString(_unref(userScore)) + "/" + _toDisplayString(_unref(maxScore)) + " 点中", 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.currentQuestion.skills, (skill, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'skill' + index
              }, [
                (skill.name.trim() != 'addition_from_ai')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(skill.name) + " > " + _toDisplayString(_unref(skillItemsName)(skill)), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (skill.gptAssessments[0] && skill.gptAssessments[0].data.skills[skill.id])
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (skill.name.trim() != 'addition_from_ai')
                        ? (_openBlock(), _createElementBlock("table", _hoisted_15, [
                            _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Criteria"),
                                _createElementVNode("th", null, "Score"),
                                _createElementVNode("th", null, "Explanation")
                              ])
                            ], -1 /* CACHED */)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skill.gptAssessments[0].data.skills[skill.id].skillItems, (item, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: 'item-' + index
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(item.name), 1 /* TEXT */),
                                  _createElementVNode("td", null, _toDisplayString(item.answer?.score) + "/" + _toDisplayString(getMaxScore(skill, item.name)), 1 /* TEXT */),
                                  _createElementVNode("td", {
                                    innerHTML: item.answer?.reason
                                  }, null, 8 /* PROPS */, _hoisted_16)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */)),
                              _createElementVNode("tr", _hoisted_17, [
                                _cache[4] || (_cache[4] = _createElementVNode("td", null, "合計スコア", -1 /* CACHED */)),
                                _createElementVNode("td", null, _toDisplayString(Array.from(Object.values(skill.gptAssessments[0].data.skills[skill.id].skillItems)).map((item) => item.answer?.score || 0).reduce(
                    (accumulator, currentValue) => accumulator + currentValue, 0)) + "/" + _toDisplayString(Array.from(Object.values(skill.gptAssessments[0].data.skills[skill.id].skillItems)).map((item) => getMaxScore(skill, item.name)).reduce(
                    (accumulator, currentValue) => accumulator + currentValue, 0)), 1 /* TEXT */),
                                _cache[5] || (_cache[5] = _createElementVNode("td", null, null, -1 /* CACHED */))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skill.gptAssessments[0].data.skills[skill.id]?.skillItems, (gptItem, gptIndex) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: 'gpt-item-' + gptIndex
                        }, [
                          (gptItem.answer && !gptItem.answer.hasOwnProperty('score'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("h3", null, _toDisplayString(camelCaseToWords(gptItem.name)), 1 /* TEXT */),
                                _createElementVNode("div", {
                                  innerHTML: gptItem.answer
                                }, null, 8 /* PROPS */, _hoisted_19)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 64 /* STABLE_FRAGMENT */))
                  : (__props.exam.isResultAfterQuestion && __props.currentQuestion.isTextarea)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                        _createCommentVNode("            TODO: check is exam page"),
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          color: "green",
                          class: "loading"
                        })
                      ]))
                    : _createCommentVNode("v-if", true)
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("div", {
              class: "exam-explain px-1",
              innerHTML: _unref(explanation)
            }, null, 8 /* PROPS */, _hoisted_21),
            _createVNode(_component_v_dialog, {
              modelValue: codeDialog.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((codeDialog).value = $event)),
              "max-width": "800"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, {
                      innerHTML: dialogHTML.value,
                      class: "d-flex pt-6"
                    }, null, 8 /* PROPS */, ["innerHTML"]),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (codeDialog.value = false))
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode("近い", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_unref(qScoreHistorySummary) && __props.currentQuestion.isTestQuestion && _unref(qScoreHistorySummary).totalCount > 1 )
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_22, [
            _createTextVNode(" 正解率 " + _toDisplayString(_unref(qScoreHistorySummary).rate) + "%（" + _toDisplayString(_unref(qScoreHistorySummary).successCount) + "/" + _toDisplayString(_unref(qScoreHistorySummary).totalCount) + "） ", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_23, "いままで " + _toDisplayString(_unref(qScoreHistorySummary).totalCount) + "回やって" + _toDisplayString(_unref(qScoreHistorySummary).successCount) + "回正解しています", 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qScoreHistorySummary).histories, (history, index) => {
              return (_openBlock(), _createBlock(_component_v_row, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(dateFormat)(history.createdAt)), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  _createVNode(_component_v_col, {
                    cols: "2",
                    class: "blue-text"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(history.score > 0 ? '正解' : '不正解'), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  _createVNode(_component_v_col, { cols: "7" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.examQScoreHistory?.examName) + " - " + _toDisplayString(_unref(getNameByExamType)(history.examType)), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (__props.currentQuestion.coursesWithLessons && __props.currentQuestion.coursesWithLessons.length > 0 && __props.schoolSetting.useCourseLesson)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "explain-title p-2 text-secondary" }, "参考レッスン", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.currentQuestion.coursesWithLessons, (courseWithLessons) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "bg-white p-2",
              key: courseWithLessons.course.id
            }, [
              _createVNode(_component_router_link, {
                class: "me-4",
                to: `/classroom/courses/${courseWithLessons.course.id}`
              }, {
                default: _withCtx(({ href }) => [
                  _createElementVNode("a", {
                    href: href,
                    target: "_blank"
                  }, _toDisplayString(courseWithLessons.course.name), 9 /* TEXT, PROPS */, _hoisted_25)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseWithLessons.lessons, (lesson) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "lesson-margin",
                  key: lesson.id
                }, [
                  _createVNode(_component_router_link, {
                    to: `/classroom/courses/${courseWithLessons.course.id}?lesson_id=${lesson.id}`
                  }, {
                    default: _withCtx(({ href }) => [
                      _createElementVNode("a", { href: href }, _toDisplayString(lesson.name), 9 /* TEXT, PROPS */, _hoisted_26)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})